import { FastDeal } from '@spilca/order_ts/v1/order/model_fast_deal_pb';
import { useI18n } from '@monorepo/i18n';
import { classNameProp } from '@monorepo/type';
import { columnData, DataTable, Head, rowData } from '@monorepo/ui-kit';
import Row from '@monorepo/ui-kit/common/Row';
import Cell from '@monorepo/ui-kit/common/Cell';
import Body from '@monorepo/ui-kit/common/Body';
import TableRow from './TableRow';
import styles from './index.module.css';

type tableProps = {
  data: FastDeal.AsObject[];
  columns: columnData[];
  subColumns: columnData[];
  isWithHeader?: boolean;
  rowKey?: string;
  round?: boolean;
} & classNameProp;

const CollapseTable = ({
  data,
  columns,
  subColumns,
  isWithHeader = true,
  className = '',
  rowKey = 'id',
  round = false
}: tableProps) => {
  const { t } = useI18n();

  return (
    <DataTable
      className={`${styles.table} ${className} ${round ? styles.round : ''}`}
    >
      {isWithHeader && (
        <Head className={styles.head}>
          <Row>
            {columns.map(
              ({ accessor, HeaderComponent, header = '', cellClass = '' }) => (
                <Cell
                  className={`${styles.th} ${cellClass}`}
                  scope="col"
                  key={`th-${accessor}`}
                >
                  {/* @ts-ignore */}
                  {HeaderComponent ? <HeaderComponent /> : t(header)}
                </Cell>
              )
            )}
          </Row>
        </Head>
      )}
      <Body>
        {data.map((row) => (
          <TableRow
            row={row}
            subColumns={subColumns}
            columns={columns}
            rowKey={rowKey}
            key={row.id}
          />
        ))}
      </Body>
    </DataTable>
  );
};

export default CollapseTable;
